(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-bienvenue"]) return;
  try {
    
  if (!customElements.get('bnd-bienvenue')) {
    customElements.define('bnd-bienvenue', class extends HTMLElement {
      connectedCallback() {
        const cle = 'bnd-bienvenue';
        const lire = () => { try { return Number(localStorage.getItem(cle) || 0); } catch (e) { return 0; } };
        this.memoriser = () => { try { localStorage.setItem(cle, String(Date.now())); } catch (e) { /* navigation privée */ } };
        const test = new URLSearchParams(location.search).get('bnd-bienvenue') === 'test';
        this.querySelector('[data-bnd-fermer]')?.addEventListener('click', () => { this.memoriser(); this.fermer(); });
        this.querySelector('[data-bnd-copier]')?.addEventListener('click', (e) => this.copier(e.currentTarget));
        // Shopify renvoie sur ?customer_posted=true#BndBienvenue : l'ancre dit quel formulaire client a été envoyé (form.id reste vide pour ce type de formulaire)
        const notreEnvoi = location.hash === '#BndBienvenue';
        if (this.dataset.inscrit === 'true' || this.dataset.erreur === 'true') { if (notreEnvoi) { this.retourInscription(); this.memoriser(); this.ouvrir(); } return; }
        if (this.dataset.actif !== 'true' && !test) return;
        if (!test && Date.now() - lire() < 30 * 24 * 3600 * 1000) return;
        const delai = test ? 1000 : Number(this.dataset.delai || 25) * 1000;
        this.minuteur = setTimeout(() => this.essayer(), delai);
        this.sortie = (e) => { if (e.clientY <= 0 && !e.relatedTarget) this.essayer(); };
        if (matchMedia('(hover: hover) and (min-width: 990px)').matches) document.addEventListener('mouseout', this.sortie);
      }
      retourInscription() {
        // Au retour de l'inscription : rester en haut de la page (l'ancre ferait descendre jusqu'au pied de page)
        // et masquer le message de la newsletter d'Horizon, qui s'affiche aussi (sa condition form.id == blank est vraie)
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* rien */ }
        document.querySelectorAll('[id^="Email-signup__message-success-"]').forEach((m) => { m.style.display = 'none'; });
        const enHaut = () => window.scrollTo(0, 0);
        enHaut();
        requestAnimationFrame(enHaut);
        if (document.readyState !== 'complete') addEventListener('load', () => setTimeout(enHaut, 0), { once: true });
      }
      disconnectedCallback() { clearTimeout(this.minuteur); document.removeEventListener('mouseout', this.sortie); }
      bandeauCookiesOuvert() {
        const b = document.getElementById('shopify-pc__banner');
        return Boolean(b && b.offsetParent !== null && getComputedStyle(b).visibility !== 'hidden');
      }
      essayer() {
        clearTimeout(this.minuteur);
        if (!this.hidden) return;
        if (this.bandeauCookiesOuvert()) { this.minuteur = setTimeout(() => this.essayer(), 4000); return; }
        document.removeEventListener('mouseout', this.sortie);
        this.ouvrir();
      }
      ouvrir() { this.hidden = false; requestAnimationFrame(() => this.classList.add('bnd-bienvenue--ouvert')); }
      fermer() { this.classList.remove('bnd-bienvenue--ouvert'); setTimeout(() => { this.hidden = true; }, 250); }
      async copier(bouton) {
        const code = this.querySelector('[data-bnd-code]')?.textContent.trim();
        try { await navigator.clipboard.writeText(code); bouton.textContent = bouton.dataset.texteOk; } catch (e) { /* copie refusée : le code reste lisible */ }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boutique-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnd-barre-mobile')) {
    customElements.define('bnd-barre-mobile', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.demarrer(), { once: true });
        else this.demarrer();
      }
      demarrer() {
        const ancre = this.dataset.cible || '';
        let section = null;
        try { section = ancre.length > 1 && ancre.startsWith('#') ? document.querySelector(ancre) : null; } catch (e) { section = null; }
        this.cible = section?.querySelector('ul, ol') || section;
        this.depart = this.closest('.shopify-section')?.querySelector('.bnd-hero__bouton');
        if (!this.cible || !this.depart) return;
        if (!this.lien) {
          this.lien = document.createElement('a');
          this.lien.className = 'button bnd-barre-mobile__bouton';
          this.lien.href = ancre;
          this.lien.tabIndex = -1;
          this.lien.textContent = this.dataset.texte || '';
          this.append(this.lien);
        }
        this.etat = { depart: true, cible: false };
        // Barre cachée aussi sur les sections qui ont déjà leur propre bouton (packs, appel final) et sur le pied de page
        this.autres = [...document.querySelectorAll('.bnd-packs, .bnd-cta, footer')];
        this.autresVisibles = new Set();
        this.observateur = new IntersectionObserver((entrees) => {
          entrees.forEach((e) => {
            if (e.target === this.depart) this.etat.depart = e.isIntersecting;
            else if (e.target === this.cible) this.etat.cible = e.isIntersecting;
            else if (e.isIntersecting) this.autresVisibles.add(e.target);
            else this.autresVisibles.delete(e.target);
          });
          const visible = !this.etat.depart && !this.etat.cible && this.autresVisibles.size === 0;
          this.classList.toggle('bnd-barre-mobile--visible', visible);
          this.setAttribute('aria-hidden', visible ? 'false' : 'true');
          if (this.lien) this.lien.tabIndex = visible ? 0 : -1;
        });
        this.observateur.observe(this.depart);
        this.observateur.observe(this.cible);
        this.autres.forEach((el) => this.observateur.observe(el));
      }
      disconnectedCallback() { this.observateur?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
